import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './ContactModal.css';

function ContactModal({ isOpen, onClose }) {
  // Block body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleCalendlyClick = () => {
    // Close ContactModal first
    onClose();
    // Then open Calendly popup
    setTimeout(() => {
      if (window.Calendly) {
        window.Calendly.initPopupWidget({
          url: 'https://calendly.com/philippstaufenberger/60min'
        });
      }
    }, 100);
  };

  if (!isOpen) return null;

  // Render modal using Portal (outside of component tree)
  return ReactDOM.createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        <div className="modal-header">
          <img src="/profile.jpg" alt="Philipp Staufenberger" className="modal-profile-photo" />
          <h2 className="modal-title">Philipp Staufenberger</h2>
          <p className="modal-subtitle">AI & Data Automation Engineer</p>
        </div>

        <div className="modal-body">
          <div className="contact-item">
            <div className="contact-icon phone-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="contact-details">
              <span className="contact-label">Telefon</span>
              <a href="tel:+4915208115356" className="contact-value">+49 15208115356</a>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon email-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M22 6l-10 7L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="contact-details">
              <span className="contact-label">E-Mail</span>
              <a href="mailto:Philipp.staufenberger@outlook.de" className="contact-value">Philipp.staufenberger@outlook.de</a>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon linkedin-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="4" cy="4" r="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="contact-details">
              <span className="contact-label">LinkedIn</span>
              <a href="https://www.linkedin.com/in/philipp-staufenberger-3a4b1822b" target="_blank" rel="noopener noreferrer" className="contact-value">Zum Profil</a>
            </div>
          </div>

          <div className="contact-item">
            <div className="contact-icon freelancer-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="contact-details">
              <span className="contact-label">Freelancermap</span>
              <a href="https://www.freelancermap.de/profil/philipp-staufenberger" target="_blank" rel="noopener noreferrer" className="contact-value">Zum Profil</a>
            </div>
          </div>

          <div className="contact-item contact-item-calendly" onClick={handleCalendlyClick}>
            <div className="contact-icon calendly-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
                <path d="M16 2v4M8 2v4M3 10h18" stroke="currentColor" strokeWidth="2"/>
                <circle cx="8" cy="14" r="1" fill="currentColor"/>
                <circle cx="12" cy="14" r="1" fill="currentColor"/>
                <circle cx="16" cy="14" r="1" fill="currentColor"/>
                <circle cx="8" cy="18" r="1" fill="currentColor"/>
                <circle cx="12" cy="18" r="1" fill="currentColor"/>
              </svg>
            </div>
            <div className="contact-details">
              <span className="contact-label">Calendly</span>
              <span className="contact-value contact-calendly-link">Termin vereinbaren</span>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <p className="modal-footer-text">Ich freue mich auf Ihre Nachricht!</p>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default ContactModal;
